export default __webpack_public_path__ + "static/media/img_18.d79ab99a.jpg";